// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3T_Op","footer":"ModalError_footer__3VFJ2"};